import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {SettingService} from "./setting.service";

@Injectable()
export class SetupService {
    constructor(private settings: SettingService,
                private http: HttpClient) {
    }
    api = 'school-program-http/api/v1';

//     // Period Setup
        //   api1.post('/period-setup', periodSetupList);
        //   api1.post('/period-setup-setting', periodSetupSettingList);
        //   api1.patch('/period-setup', activitySessionList);
        //   api1.post('/period-setup-delete/:periodSetupId', activitySessionList);

    getPeriodSetup(params: any): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/period-setup';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/period-setup';

        return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
    }

    getPeriodSetupSetting(params: any): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/period-setup-setting';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/period-setup-setting';

        return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
    }
    
    createPeriodSetupSetting(params: any): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/period-setup-setting';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/period-setup-setting';
        
        return this.http.put<any>(requestUrl, params, this.settings.httpOptionWithSession());
    }

    updatePeriodSetupSetting(params: any): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/period-setup-setting';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/period-setup-setting';
        
        return this.http.patch<any>(requestUrl, params, this.settings.httpOptionWithSession());
    }

    deletePeriodSetupSetting(settingId: number): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/period-setup-setting-delete/' + settingId;
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/period-setup-setting-delete/' + settingId;

        return this.http.delete<any>(requestUrl, this.settings.httpOptionWithSession());
    }

    approverSetupList(params: any): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/approver-setup';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/approver-setup';

        return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
    }

    approverSetupSettingCreate(params: any): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/approver-setup-setting';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/approver-setup-setting';

        return this.http.put<any>(requestUrl, params, this.settings.httpOptionWithSession());
    }

    approverSetupSettingList(params: any): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/approver-setup-setting';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/approver-setup-setting';

        return this.http.post<any>(requestUrl, params, this.settings.httpOptionWithSession());
    }


    approverSetupSettingUpdate(params: any): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/approver-setup-setting';
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/approver-setup-setting';

        return this.http.patch<any>(requestUrl, params, this.settings.httpOptionWithSession());
    }

    approverSetupSettingDelete(id: number): Observable<any[]> {
        const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/approver-setup-setting-delete/' + id;
        // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/approver-setup-setting-delete/' + id;

        return this.http.delete<any>(requestUrl, this.settings.httpOptionWithSession());
    }

}
